import type { MutationConfig } from "apps/visits/core/lib/react-query";
import type { AxiosError } from "axios";
import { useMutation } from "react-query";
import { VouchersDistributionsRepository } from "../vouchers-distribution.api";
import type { AuthenticateUserErrorResponse } from "./authenticate-user.types";

const vouchersDistributionsRepository = new VouchersDistributionsRepository();

type UseAuthenticateUserOptions = {
  config?: MutationConfig<
    typeof vouchersDistributionsRepository.authenticateUser,
    AxiosError<AuthenticateUserErrorResponse>
  >;
};

export const useAuthenticateUser = ({ config }: UseAuthenticateUserOptions) => {
  return useMutation({
    ...config,
    mutationFn: (data) => vouchersDistributionsRepository.authenticateUser(data),
  });
};
